export default __webpack_public_path__ + "static/media/tenant_1.dea3be85.png";